export default{
    methods: {
        goBack(){
            console.log('try to goBack from history: %c'+ this.$router.history.current.name, 'background: #00b0b0; color: #fff')
            let historyName = this.$router.history.current.name;
            // prevent user from going back to training summary
            if(historyName === 'TrainingSummary') {
                return this.$router.push({name: 'Trainings'});
            }
            // go back in history
            this.$root.$emit('goingBack');
            this.$router.go(-1)
        },
        goTo(routeName, routeSlug, routeTitle, routeId){
            //console.log('goTo:', routeName, '| slug:', routeSlug, '| title:', routeTitle, '| id:', routeId)
            // handle logout special route name
            if(routeName === 'UserLogout'){
                return this.logout();
            }
            // external url
            if(/(http(s?)):\/\//i.test(routeName)){
                return window.location.replace(routeName)
            }
            // internal url
            if(routeName !== null && routeSlug !== null){
                this.$router.push({name: routeName, params: { slug: routeSlug, title : routeTitle, id : routeId }}).catch(err => {})
            }
        },
        logout(){
            console.log("%c logout alert! ", 'background: #ff0000; color: #fff');
            this.$ionic.alertController
                .create({
                    header: 'Wyloguj się',
                    message: 'Czy na pewno chcesz się wylogować?',
                    buttons: [
                        {
                            text: 'Anuluj',
                            role: 'cancel',
                            handler: () => {
                                /* *** */
//                                    this.$ga.event('user', 'logout cancel')
                            },
                        },
                        {
                            text: 'Tak',
                            handler: () => {
                                this.$store.dispatch('AUTH_LOGOUT_REQUEST').then(() => {
                                    this.$router.push({name: 'Login'}).catch(err => {})
                                    return this.$store.dispatch('GLOBAL_TOAST','Wylogowano poprawnie.');
                                })
                            }
                        }
                    ],
                    mode: 'md'
                })
                .then(a => a.present())
        },
    }
}